import React, { useContext } from 'react';
import type { CrmOrg } from '../../../../types/CrmOrgs';

export interface DefaultEnvContextType {
  crmOrgId: string | undefined;
  crmOrg: CrmOrg | undefined;
  changeEnvironment: (targetCrmOrgId: string | null) => void;
}

export const DefaultEnvContext = React.createContext<DefaultEnvContextType | undefined>(undefined);

const useDefaultEnvContext = () => {
  const ctx = useContext(DefaultEnvContext);
  if (!ctx) {
    throw new Error('useDefaultEnvContext must be used within a DefaultEnvContext');
  }
  return ctx;
};

export const useDefaultEnvId = () => useDefaultEnvContext().crmOrgId;

export const useDefaultEnv = () => useDefaultEnvContext().crmOrg;

export const useChangeDefaultEnv = () => useDefaultEnvContext().changeEnvironment;
